import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/css/style.css";
// import { getRequest } from "@/api/api";
// import { http } from "./utils/http";
import { initSourceTracking } from "./utils/sourceTracker";

import HistoryManager from "./components/historyManager/HistoryManager.vue";
import RightFixedPage from "./components/rightFixedPage/RightFixedPage.vue";
import MarkdownWithLatex from "./components/MarkdownWithLatex/MarkdownWithLatex.vue"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import locale from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale/lang/zh-CN'; // 引入中文语言包
import 'animate.css';
import store from './store/index'  // 引入 store
import Vuex from 'vuex'

import 'katex/dist/katex.min.css'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import "nprogress/nprogress.css";
import './assets/iconfont/iconfont.js'

import SvgIcon from './components/SvgIcon/index.vue'
import HintButton from './components/HintButton/index.vue'


// 全局注册
Vue.use(mavonEditor)

import MarkdownEditor from './components/MarkdownEditor/MarkdownEditor.vue'
// import WangEditor from "./components/WangEditor/WangEditor.vue";
import TableComponent from './components/TableComponent/index.vue'

import { formatTime, formatTs } from './utils/fiflter'; // 假设工具函数在 dateUtils.js 中

Vue.filter('formatTime', formatTime);
Vue.filter('formatTs', formatTs);
Vue.use(Vuex)  // 安装 Vuex
Vue.use(ElementUI, { locale })
// Vue.prototype.http = http;
Vue.config.productionTip = false;

// 全局注册组件
Vue.component("HistoryManager", HistoryManager); // 注册
Vue.component("RightFixedPage", RightFixedPage); // 注册
Vue.component("MarkdownWithLatex", MarkdownWithLatex); // 注册
Vue.component("MarkdownEditor", MarkdownEditor); // 注册
// Vue.component("WangEditor", WangEditor); // 注册
Vue.component('SvgIcon', SvgIcon)
Vue.component('HintButton', HintButton)
Vue.component('TableComponent', TableComponent)


import { deviceDetector } from './utils/device';
Vue.prototype.$device = deviceDetector;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

// 初始化用户来源追踪
// 放在Vue实例创建后调用，确保DOM和路由都已准备就绪
initSourceTracking();
